module.exports = __webpack_public_path__ + "img/b1.55127dae.png";